import {useEffect} from 'react';

const useCloseOnScroll = (isOpen: boolean, close: () => void) => {
    useEffect(() => {
        if(!isOpen) return;
        const onScroll = () => close();
        window.addEventListener('scroll', onScroll, true);
        return () => window.removeEventListener('scroll', onScroll, true);
    }, [isOpen]);
};

export default useCloseOnScroll;
